<template>
  <div class="advices">
    <p class="h2 text-center mt-sm-4 mt-md-5 mt-4 mb-2">{{ $t('after_buying_title') }}</p>
    <hr class="underline mb-4 mb-sm-4 mb-lg-5">
    <p class="intro">{{ $t('after_buying_description') }}</p>
    <div class="stories p-3 p-sm-4 p-lg-5">
      <div class="advices__general">
        <div class="advices__general__section">
          <p class="advices__general__section-title">{{ $t('after_buying_rights') }}</p>
          <p class="intro-text pl-2 pr-2">{{ $t('after_buying_rights_text1') }}</p>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_rights_text2')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_rights_text3')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_rights_text4')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_rights_text5')"></p>
          </div>
        </div>
      </div>
      <div class="advices__general purple">
        <div class="advices__general__section">
          <p class="advices__general__section-title">{{ $t('after_buying_product') }}</p>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_product_text1')"></p>
          </div>
        </div>
      </div>
      <div class="advices__general orange">
        <div class="advices__general__section">
          <p class="advices__general__section-title">{{ $t('after_buying_safe') }}</p>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_safe_text1')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_safe_text2')"></p>
          </div>
        </div>
      </div>
      <div class="advices__general blue">
        <div class="advices__general__section">
          <p class="advices__general__section-title">{{ $t('after_buying_things') }}</p>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_things_text2')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_things_text1')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_things_text3')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_things_text4')"></p>
          </div>
          <div class="advice d-flex pl-2 pr-2">
            <font-awesome-icon icon="check-circle" />
            <p v-html="$t('after_buying_things_text5')"></p>
          </div>
        </div>
      </div>
      <p class="text-secondary mt-4 mb-0">{{ $t('home_note1') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'advices'
}
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

.advices {
    max-width: 1000px;
    margin: auto;
    p.h2 {
        font-family: 'Kalam', sans-serif;
        text-transform: uppercase;
    }
    .underline {
        margin: 0 auto;
        border-width: 2px;
        max-width: 400px;
        border-color: #e31b18;
        margin-bottom: 25px;
    }
    .intro {
      font-size: 0.95rem;
      color: black;
    }
    .stories {
      background-color: white;
      border: solid black;
      border-width: 3px 4px 3px 4px;
      border-radius:60% 1% 20% 1%/0.3% 20% 1% 20%;
      overflow: hidden;
      .intro-text {
        font-size: 1.05rem;
        font-family: "Architects Daughter", "Comic Sans MS";
      }
      .advice {
        margin-bottom: 15px;
        text-align: justify;
        svg {
          color: #4caf50;
          font-size: 1.5rem;
          margin: auto 0;
          margin-right: 10px;
        }
        p {
          font-size: 1.05rem;
          margin: auto 0;
          font-family: "Architects Daughter", "Comic Sans MS";
        }
      }
    }
    &__general {
      background-color: #ace8dc44;
      border: 1px solid #ace8dc;
      margin-bottom: 15px;
      &__section {
        padding: 15px;
        &-title {
          font-size: 1.15rem;
          font-family: 'Kalam', sans-serif;
          letter-spacing: 0.01rem;
          background: #ade8dc66;
          padding: 5px;
          padding-top: 9px;
          padding-left: 15px;
          text-transform: uppercase;
        }
      }
    }
    &__general.purple {
      background-color: #ddc4e744;
      border: 1px solid #ddc4e7;
      .advices__general__section {
        &-title {
          background: #ddc4e766;
        }
      }
    }
    &__general.blue {
      background-color: #b7dbf244;
      border: 1px solid #b7dbf2;
      .advices__general__section {
        &-title {
          background: #b7dbf266;
        }
      }
    }
    &__general.yellow {
      background-color: #faeba644;
      border: 1px solid #faeba6;
      .advices__general__section {
        &-title {
          background: #faeba666;
        }
      }
    }
    &__general.orange {
      background-color: #f5d2ad44;
      border: 1px solid #f5d2ad;
      .advices__general__section {
        &-title {
          background: #f5d2ad66;
        }
      }
    }
  }

  @include media-breakpoint-down(md) {
    .underline {
      max-width: 250px;
    }
  }
</style>

